module.exports = __webpack_public_path__ + "img/default-logo.abbb0971.jpg";